module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAaAgMAAADK7ZTuAAAADFBMVEUAAAAQeewQeewQeezO7IIGAAAAA3RSTlMAgH8BTzA4AAAAPElEQVQI17XJMREAIRTE0NxcgQU6rKAMkIYExNAyn5hgi1ds4I/JQ3tEHIpuki4+rQZvDFuTN4ahNHAZLpA4NDWcwAcPAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/downStrangle.png
// module id = 2lMy
// module chunks = 1